import React, { Component } from "react";
import { Modal, Fade, Button, IconButton, Grid, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import '../../../css/EditDetailsPopup.css';
import '../../../css/Login.css';
import '../../../css/PasswordUpdatePopup.css';
import get_and_post_data_skeleton from '../../common/common/get_and_post_data_skeleton';
const paths = require('../../../paths.json');

class DeleteAccountPopup extends Component {
   constructor(props) {
      super(props);
      this.state = { errorMsg: '' };
      this.deleteAccountPost = this.deleteAccountPost.bind(this);
   }

   componentDidMount() {
      this.data_func(paths.BACKEND_URL + "api/settings_page_profile_delete_account", 'get');
   }

   deleteAccountPost(res) {
      if (res.data.account_deleted) {
         window.location.assign('/');
         this.setState({ errorMsg: '' });
      } else {
         this.setState({ errorMsg: 'Error, please try again' });
      }
   }

   submitDeleteAccount(event) {
      event.preventDefault();
      const form_data = new FormData();
      this.data_func(paths.BACKEND_URL + "api/settings_page_profile_delete_account_submit", 'post', false, form_data, this.deleteAccountPost);
   }

   data_func = get_and_post_data_skeleton;

   render() {
      return (
         <Modal
            disableAutoFocus={true}
            open={this.props.open_modal}
            sx={{
               backgroundColor: 'rgba(0,0,0,0.47)',
               borderRadius: '5px', 
               overflow: 'scroll',
               minWidth: '100vw',
               outline: '0',
               display: 'flex',
               zIndex: '1100',
               lineHeight: '25px',
               textAlign: 'center',
               maxHeight: '100vh',
               minHeight: '100vh',
            }}
         >
            <Grid sx={{
               height: 'auto',
               borderRadius: window.innerWidth <= 600 ? '0px' : '5px',
               margin: 'auto',
               textAlign: 'center',
               display: 'flex'
            }} xs={12} justifyContent='center' textAlign='center'>
               <Grid container xs={12} alignItems="center" justifyContent="center" direction="column" style={{
                  width: '100%',
                  display: 'flex',
                  borderRadius: window.innerWidth <= 600 ? '0px' : '5px',
               }}>
                  <Grid sx={{
                     width: '100vw',
                     maxWidth: '600px',
                     height: 'auto',
                     backgroundColor: '#fff',
                     borderRadius: window.innerWidth <= 600 ? '0px' : '10px',
                     margin: 'auto',
                     boxShadow: '0 5px 25px 0 rgba(35, 40, 105, 0.04)',
                     paddingTop: '5px',
                     paddingBottom: '5px',
                  }}>
                     <Grid item xs={6} style={{
                        top: '0px',
                        padding: '0px',
                        float: 'right',
                        paddingRight: '2%',
                        paddingTop: '2%',
                        textAlign: 'right',
                        flexBasis: '33%',
                     }}>
                        <IconButton style={{
                           padding: '0px',
                           margin: '0px',
                           textAlign: 'right',
                           color: '#9CA3B4',
                           backgroundColor: 'transparent',
                           justifyContent: 'right',
                           minWidth: '30px',
                        }} onClick={this.props.close_delete_account}>
                           <CloseIcon style={{
                              fontSize: '30px',
                              fontWeight: '300',
                              textAlign: 'right',
                              display: 'flex',
                              position: 'absolute',
                              padding: '0px',
                           }} />
                        </IconButton>
                     </Grid>

                     <Grid container xs={12} style={{
                        padding: '0px',
                        height: '30px',
                        paddingTop: '20px',
                        borderRadius: '0px',
                        backgroundColor: '#fff',
                        borderTopLeftRadius: '5px',
                        borderTopRightRadius: '5px',
                        flexWrap: 'nowrap'
                     }}>
                        <Grid item xs={12} style={{ alignSelf: 'center', textAlign: 'center', marginBottom: '10px' }}>
                           <p style={{ fontSize: '20px', margin: '0px 0px 0px 0px', fontWeight: '600', fontFamily: 'Roboto' }}>Delete Account</p>
                           <p style={{ fontSize: '14px', margin: '5px 0px 0px 0px', color: '#6E89AF', fontWeight: '500', fontFamily: 'Roboto' }}>
                              Please confirm your account deletion
                           </p>
                        </Grid>
                     </Grid>

                     <Grid xs={12} style={{ padding: '20px', textAlign: 'center', marginTop: '30px',  }}>
                        <Typography sx={{ color: 'var(--danger-color)', fontSize: '16px', fontWeight: '600', margin: '0px auto 40px auto', backgroundColor: '#ffdede', padding: '10px', width: '90%', borderRadius: '5px', textTransform: 'uppercase' }}>
                        This action cannot be undone. <br /> Any existing memberships will be cancelled.
                        </Typography>
                        <Typography className="error_message" sx={{ color: 'red', marginBottom: '25px' }}>{this.state.errorMsg}</Typography>
                        
                        <Grid container spacing={2}>
                           <Grid item xs={6}>
                              <Button
                                 disableRipple
                                 fullWidth
                                 variant="contained"
                                 sx={{
                                    backgroundColor: 'var(--brand-color)',
                                    color: '#fff',
                                    fontSize: '16px',
                                    textTransform: 'none',
                                    marginBottom: '0px',
                                    borderRadius: '8px',
                                    boxShadow: 'none',
                                    fontWeight: '700',
                                    ':hover': {
                                       backgroundColor: 'var(--brand-color-hover)',
                                       boxShadow: 'none',

                                    },
                                 }}
                                 onClick={this.props.close_delete_account}
                              >
                                 Keep My Account
                              </Button>
                           </Grid>
                           <Grid item xs={6}>
                              <Button
                                 disableRipple
                                 fullWidth
                                 variant="contained"
                                 sx={{
                                    backgroundColor: 'var(--danger-color)',
                                    fontSize: '16px',
                                    textTransform: 'none',
                                    marginBottom: '0px',
                                    borderRadius: '8px',
                                    boxShadow: 'none',
                                    fontWeight: '700',
                                    ':hover': {
                                       backgroundColor: 'var(--danger-color-hover)',
                                       color: 'white',
                                       boxShadow: 'none',
                                    },
                                 }}
                                 onClick={(event) => this.submitDeleteAccount(event)}
                              >
                                 Delete Account
                              </Button>
                           </Grid>
                        </Grid>
                     </Grid>
                  </Grid>
               </Grid>
            </Grid>
         </Modal>
      );
   }
}

export default DeleteAccountPopup;
